import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import { useErrorBoundary } from "component-library";
import { authAxios as axios } from "shared-auth";
import { HALManager, UserManager } from "app/core";
import { GET_TRAINING_QUERY_KEY } from "./useGetTraining";
import { getApiUrl } from "services/UrlBuilder";

export function useUpdateTraining() {
  const queryClient = useQueryClient();
  const captureError = useErrorBoundary();

  return useMutation<
    { id: string; notes: string },
    AxiosError,
    { notes: string }
  >(
    async (body) => {
      const { data } = await axios.put(
        getApiUrl(HALManager.updateTrainingUrl(UserManager.userId)),
        body
      );

      return data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(GET_TRAINING_QUERY_KEY);
      },
      onError: (error) => captureError(error),
    }
  );
}
